export const getUTCDate = (value) => {
  return new Date(
    Date.UTC(
      value.getUTCFullYear(),
      value.getUTCMonth(),
      value.getUTCDate(),
      value.getUTCHours(),
      value.getUTCMinutes(),
      value.getUTCSeconds(),
    ),
  )
}

export const fetchData = async ({fetchFunction, timeout = 2000, params = ''}) => {
  if (params === undefined) {
    params = null
  }
  try {
    await new Promise((resolve) => setTimeout(resolve, timeout))
    const response = await fetchFunction(params)

    if (response.data && response.data.data) {
      return response.data.data
    } else {
      throw new Error('Respuesta de API incorrecta') // Otra acción en caso de respuesta incorrecta
    }
  } catch (error) {
    console.error('Error al obtener los datos:', error)
    return null // Otra acción o valor predeterminado en caso de error
  }
}
